import React, { Component } from 'react';
import { Grid, Table, TableHeaderRow, 
	TableRowDetail, TableColumnVisibility, TableSelection, PagingPanel, TableFilterRow
} from '@devexpress/dx-react-grid-bootstrap4';
import PropTypes from 'prop-types';
import { RowDetailState, SelectionState, PagingState, IntegratedPaging, IntegratedFiltering, FilteringState } from '@devexpress/dx-react-grid';

class DxReactGridBootstrap extends Component {
	render() {
		const { rows, columns } = this.props;
		return <Grid
			rows={rows}
			columns={columns}
		>
			{this.columnFilterState()}
			{this.rowDetailState()}
			{this.selectionState()}
			{this.pagingState()}
			{this.integratedFiltering()}
			{this.integratedPaging()}
			{this.tableRender()}
			{this.tableHeaderRowRender()}
			{this.hiddenColumns()}
			{this.tableRowDetail()}
			{this.tableSelection()}
			{this.columnFilterRow()}
			{this.pagingPanel()}
		</Grid>
	}

	selectionState = () => {
		if(!!this.props.onSelectionChange === false) {
			return null;
		}
		return <SelectionState 
			selection = { this.props.selection }
			onSelectionChange = { this.props.onSelectionChange }
		/>;
	}

	rowDetailState = () => {
		if(!!this.props.tableRowComponent === false) {
			return null;
		}
		let props = {};
		if(this.props.hasOwnProperty('expandedRowIds')) {
			props.expandedRowIds = this.props.expandedRowIds;
		};
		return <RowDetailState 
			{...props}
		/>;
	}

	pagingState = () => {
		if(!!this.props.pageSize === false) {
			return null
		}
		return <PagingState 
			defaultCurrentPage = { 0 }
			defaultPageSize = { this.props.pageSize }
		/>;
	}

	integratedPaging = () => {
		if(!!this.props.pageSize === false) {
			return null
		}
		return <IntegratedPaging />
	}

	tableRender = () => {
		if(!!this.props.customCellFn === false) {
			return <Table />;
		}
		return <Table 
			cellComponent = { this.customCellCreate('customCellFn') }
		/>;
	}

	tableHeaderRowRender = () => {
		if(!!this.props.customHeaderCellFn === false) {
			return <TableHeaderRow />;
		}
		return <TableHeaderRow 
			cellComponent = { this.customCellCreate('customHeaderCellFn') }
		/>;
	}

	customCellCreate = customCellFn => (props) => {
		const customCell = this.props[customCellFn](props);
		if(customCell === false) {
			if(customCellFn === 'customCellFn') {
				return <Table.Cell {...props} />;
			} else if(customCellFn === 'customHeaderCellFn') {
				return <TableHeaderRow.Cell {...props} />;
			}
		}
		return customCell;
	}

	tableRowDetail = () => {
		if(!!this.props.tableRowComponent === false) {
			return null;
		}
		return <TableRowDetail 
			contentComponent={this.props.tableRowComponent}
		/>;
	}

	tableSelection = () => {
		if(!!this.props.onSelectionChange === false) {
			return null;
		}
		return <TableSelection 
			selectByRowClick
			highlightRow
			showSelectionColumn={false}
		/>
	}

	columnFilterRow = () => {
		if(!!this.props.columnFilter === false) {
			return null;
		}
		return <TableFilterRow />;
	}

	columnFilterState = () => {
		if(!!this.props.columnFilter === false) {
			return null;
		}
		const { filterColumnException } = this.props;
		const filteringStateColumnExtensions = !!filterColumnException === false ? [] : filterColumnException;
		return <FilteringState		  
			defaultFilters={[]}
			columnExtensions= {filteringStateColumnExtensions}
		/>;
	}

	integratedFiltering = () => {
		if(!!this.props.columnFilter === false) {
			return null;
		} 
		return <IntegratedFiltering />;
	}

	hiddenColumns = () => {
		if(!!this.props.hiddenColumns === false) {
			return null;
		}
		return <TableColumnVisibility 
			contentComponent={this.props.hiddenColumns}
		/>;
	}

	pagingPanel = () => {
		if(!!this.props.pageSize === false) {
			return null
		}  
		return <PagingPanel
			pageSizes = { [this.props.pageSize] }
		/>
	}
}

DxReactGridBootstrap.propTypes = {
	rows: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	tableRowComponent: PropTypes.func,
	hiddenColumns: PropTypes.array,
	expandedRowIds: PropTypes.array,
	columnFilter: PropTypes.bool,
	pageSize: PropTypes.number,
	customCellFn: PropTypes.func
}

export default DxReactGridBootstrap;


// WEBPACK FOOTER //
// ./src/components/tableWrappers/DxReactGridBoostrapWrapper.jsx